module.exports = __webpack_public_path__ + "components/flag/static/square/de-319838875ebe65d1d917b5b389814169.svg";